"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ProjectMgrv2;
    }
});
const _SqlMgrv2 = /*#__PURE__*/ _interop_require_default(require("./SqlMgrv2"));
const _SqlMgrv2Trans = /*#__PURE__*/ _interop_require_default(require("./SqlMgrv2Trans"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ProjectMgrv2 = class ProjectMgrv2 {
    static getSqlMgr(context, base, ncMeta = null) {
        if (ncMeta) return new _SqlMgrv2.default(context, base, ncMeta);
        if (!this.sqlMgrMap[base.id]) {
            this.sqlMgrMap[base.id] = new _SqlMgrv2.default(context, base);
        }
        return this.sqlMgrMap[base.id];
    }
    static async getSqlMgrTrans(context, base, // todo: tobe changed
    ncMeta, source) {
        const sqlMgr = new _SqlMgrv2Trans.default(context, base, ncMeta, source);
        await sqlMgr.startTransaction(source);
        return sqlMgr;
    }
};
ProjectMgrv2.sqlMgrMap = {};
